export const licenseRoutes = [
    {
        path: '',
        name: 'License',
        exact: true,
        component: () => import('../views/LicenseIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'All Licenses' }],
            godOnly: true,
        },
    },
];
